import { PanelCard } from '../ui/PanelCard';
import { BreakdownBar } from './BreakdownBar';
import { useClusterStore } from '../../stores/clusterStore';
import { makeClusterColor } from '../../lib/clusterColor';
import type { BreakdownGroup } from '../../lib/types';

export interface BreakdownPanelProps {
  title: string;
  items: BreakdownGroup[];
  accent: string;
  scroll?: boolean;
}

export function BreakdownPanel({
  title,
  items,
  accent,
  scroll,
}: BreakdownPanelProps) {
  const clusters = useClusterStore(s => s.clusters);
  const colorFor = makeClusterColor(clusters);
  const visible = items
    .filter(it => it.scaled > 0)
    .sort((a, b) => a.key.localeCompare(b.key));
  const max = visible.reduce((m, it) => Math.max(m, it.scaled), 0);
  return (
    <PanelCard title={title} className="min-w-0">
      {visible.length === 0 ? (
        <div className="px-3.5 py-4 text-[11px] text-textMute">Sem dados.</div>
      ) : (
        <div className={scroll ? 'max-h-[280px] overflow-auto py-1' : 'py-1'}>
          {visible.map(it => (
            <BreakdownBar
              key={it.key}
              item={it}
              max={max}
              accent={accent}
              colorFor={colorFor}
            />
          ))}
        </div>
      )}
    </PanelCard>
  );
}

export default BreakdownPanel;
